import React, { useState, useEffect } from "react";
import { Button } from "../../components/Utilities";
import { apiService } from "../../../services/apiService";
import "./PaymentModal.css";
import pro from "../../assets/person.svg";
import { Loading } from "../../components/Loading"; // Ensure Loading is imported

// Utility function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// Upload Payment Modal Component
export const UploadPaymentModal = ({
  isOpen,
  onClose,
  car,
  onPaymentSubmitted,
  viewMode = false,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  // const [transactionAmount, setTransactionAmount] = useState(car.awardedToDealerAmount);
  const [bankReferenceId, setBankReferenceId] = useState("");
  const [bankAccountNo, setBankAccountNo] = useState("");
  const [bankAccountName, setBankAccountName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [maxDate, setMaxDate] = useState("");
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const amount=car.awardedToDealerAmount

  // Set default transaction date and max date to today on mount
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setTransactionDate(today);
    setMaxDate(today);
  }, []);

  useEffect(() => {
      if (car?.paymentInfo?.length > 0) {
        const info = car.paymentInfo[0];
        setPaymentInfo(info);
        if (viewMode) {
          // setTransactionAmount(info.transactionAmount?.toString() || "");
          setBankReferenceId(info.bankReferenceId || "");
          setBankAccountNo(info.bankAccountNo || "");
          setBankAccountName(info.bankAccountName || "");
          setIfscCode(info.ifscCode || "");
          setPaymentMethod(info.paymentMethod || "");
          setTransactionDate(info.transactionDate || "");
          setPreviewImages(
            (info.files || []).map((f, i) => ({
              id: i,
              url: f.url,
              name: f.name,
            }))
          );
        }
      }
    }, [car, viewMode]);

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    const previews = files.map((file) => ({
      id: Date.now() + Math.random(),
      url: URL.createObjectURL(file),
    }));
    setPreviewImages(previews);
  };

  const isSubmitDisabled = !(
    // transactionAmount &&
    bankReferenceId &&
    bankAccountNo &&
    bankAccountName &&
    ifscCode &&
    paymentMethod &&
    transactionDate &&
    selectedFiles.length > 0 &&
    car.flow_entity_id
  );

  const handleSubmitProof = async () => {
    if (isSubmitDisabled) {
      setError("Please fill in all required fields and upload payment proof.");
      return;
    }

    if (!car.flow_entity_id) {
      setError("Missing Flow Entity ID. Please try again or contact support.");
      return;
    }

    console.log("🔍 PaymentModal - Car object received:", car);
    console.log(
      "🔍 PaymentModal - Car awardedToDealerAmount:",
      car.awardedToDealerAmount
    );
    console.log("🔍 PaymentModal - Car awardedAmount:", car.awardedAmount);
    console.log("🔍 PaymentModal - Car keys:", Object.keys(car || {}));

    // const paymentAmount = Number(transactionAmount);
    const awardedAmount = car.awardedToDealerAmount || car.awardedAmount || 0;

    console.log("🔍 PaymentModal - Payment validation:", {
      // paymentAmount,
      awardedAmount,
      carAwardedToDealerAmount: car.awardedToDealerAmount,
      carAwardedAmount: car.awardedAmount,
    });

    // if (paymentAmount !== awardedAmount) {
    //   setError(
    //     `Payment amount (₹${paymentAmount.toLocaleString()}) must exactly equal the Awarded Amount (₹${awardedAmount.toLocaleString()}).`
    //   );
    //   return;
    // }

    const dealerBankAccountNo = car.dealerBankAccountNo || car.bankAccountNo;
    const dealerBankAccountName =
      car.dealerBankAccountName || car.bankAccountName;
    const dealerIfscCode = car.dealerIfscCode || car.ifscCode;

    if (dealerBankAccountNo && bankAccountNo !== dealerBankAccountNo) {
      setError(
        `Bank account number must match the one provided during dealer onboarding (${dealerBankAccountNo}).`
      );
      return;
    }

    if (dealerBankAccountName && bankAccountName !== dealerBankAccountName) {
      setError(
        `Bank account name must match the one provided during dealer onboarding (${dealerBankAccountName}).`
      );
      return;
    }

    if (dealerIfscCode && ifscCode !== dealerIfscCode) {
      setError(
        `IFSC code must match the one provided during dealer onboarding (${dealerIfscCode}).`
      );
      return;
    }

    setLoading(true);
    setError(null);

    try {
      console.log("Starting submitPaymentProof with data:", {
        carId: car.id,
        flow_entity_id: car.flow_entity_id,
        // transactionAmount,
        bankReferenceId,
        paymentMethod,
        transactionDate,
        fileCount: selectedFiles.length,
      });

      const uploadedFiles = [];
      for (let index = 0; index < selectedFiles.length; index++) {
        const file = selectedFiles[index];
        const base64Data = await fileToBase64(file);
        const base64String = base64Data.replace(/^data:[^;]+;base64,/, "");

        const fileName = `payment_${
          car.originalCarId || car.id
        }_${Date.now()}_${index}_${Math.random()
          .toString(36)
          .substr(2, 9)}.${file.name.split(".").pop()}`;

        const fileData = {
          file: base64String,
          folder: "payment-info",
          fileName,
          metadata: {
            contentType: file.type,
            originalName: file.name,
            size: file.size,
            carId: car.originalCarId || car.id,
            flow_entity_id: car.flow_entity_id,
            dealerId:
              localStorage.getItem("dealerId") ||
              localStorage.getItem("authToken")?.split("_")[0] ||
              "adminuid",
            paymentType: "payment_info",
          },
        };

        console.log(`Uploading file ${index + 1}/${selectedFiles.length}:`, {
          fileName,
          size: file.size,
          contentType: file.type,
          base64Length: base64String.length,
        });

        const uploadResponse = await apiService.uploadFile(fileData);

        console.log(
          `Upload response for file ${index + 1}:`,
          uploadResponse.data
        );

        const publicUrl = uploadResponse.data?.publicUrl || "";

        uploadedFiles.push({
          name: file.name,
          size: file.size,
          type: file.type,
          fileName,
          url: publicUrl,
        });
      }

      const paymentInfoData = {
        flow_entity_id: car.flow_entity_id,
        transactionAmount: Number(amount),
        bankReferenceId,
        bankAccountNo,
        bankAccountName,
        ifscCode,
        files: uploadedFiles,
        paymentMethod,
        transactionDate,
      };

      console.log(
        "Submitting payment info to /submitPaymentInfo:",
        paymentInfoData
      );

      let paymentResponse;
      try {
        paymentResponse = await apiService.submitPaymentInfo(paymentInfoData);
      } catch (error) {
        if (error.response?.status === 404) {
          console.warn(
            "Primary endpoint /submitPaymentInfo failed with 404. Trying fallback endpoint /submitPaymentDetails..."
          );
          paymentResponse = await apiService.submitPaymentDetails(
            paymentInfoData
          );
        } else {
          throw error;
        }
      }

      console.log("Payment submission response:", paymentResponse);

      if (paymentResponse.success || paymentResponse.status === "success") {
        previewImages.forEach((preview) => URL.revokeObjectURL(preview.url));
        setPreviewImages([]);
        setSelectedFiles([]);
        setSubmitted(true);
        onPaymentSubmitted(car.id);
      } else {
        setError("Payment submission failed. Unexpected response from server.");
      }
    } catch (error) {
      console.error("Error in submitPaymentProof:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        endpoint: error.config?.url || "unknown",
      });

      if (error.message.includes("submitPaymentDetails is not a function")) {
        setError("Fallback endpoint not configured. Please contact support.");
      } else if (error.response?.status === 404) {
        setError(
          "Payment submission endpoint not found or Flow Entity is invalid. Please contact support."
        );
      } else if (error.response?.status === 400) {
        setError(
          `Invalid request: ${
            error.response.data?.message ||
            error.response.data?.error ||
            "Check payload format and payment details"
          }`
        );
      } else if (error.response?.status === 401) {
        setError("Unauthorized. Please log in again.");
      } else if (error.response?.status === 500) {
        setError("Server error. Please try again later.");
      } else {
        setError(
          error.message || "Failed to submit payment proof. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDateClick = (e) => {
    e.target.showPicker();
    e.target.focus();
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const handleCloseImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImage(null);
  };

  if (!isOpen) return null;

  return (
    <div className="paymentModal">
      <div className="modal-overlay">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="model-header">
         <p> {viewMode ? "Payment Proof (Pending Review)" : "Upload Payment Proof"}</p>
            <button className="modal-close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="model-body">
            {loading && <Loading />} {/* Add Loading component inside model-body */}
            {error && <p className="error web-error">{error}</p>}
            <div className="right-part">
              <div className="input-group">
                <select
                  name="paymentMethod"
                  id="paymentMethod"
                  required
                  value={paymentMethod}
                  onChange={(e) =>!viewMode && setPaymentMethod(e.target.value)}
                  className="payment-input"
                >
                  <option value="">Select Payment Method</option>
                  <option value="netBanking">Net Banking</option>
                  <option value="upi">UPI</option>
                  {/* <option value="creditCard">Credit Card</option>
                  <option value="debitCard">Debit Card</option> */}
                </select>

                <label className="input-label" htmlFor="transactionAmount">
                  Transfer Amount*
                </label>
                <input
                  type="tel"
                  id="transactionAmount"
                  className="payment-input"
                  placeholder="Enter Transfer Amount"
                  pattern="[0-9]{10}"
                  value={amount}
                  maxLength={9}
                disabled
                  // onChange={(e) =>
                  //   !viewMode && setTransactionAmount(e.target.value)
                  // }
                  required
                />

                <label className="input-label" htmlFor="bankAccountNo">
                  Bank Account Number*
                </label>
                <input
                  type="text"
                  id="bankAccountNo"
                  className="payment-input"
                  placeholder="Enter Bank Account Number"
                  value={bankAccountNo}
                  onChange={(e) =>
                    !viewMode && setBankAccountNo(e.target.value)
                  }
                  required
                  maxLength={18}
                  pattern="^[0-9]{9,18}$"
                  title="Bank account number must be 9 to 18 digits only"
                />

                <label className="input-label" htmlFor="bankAccountName">
                  Bank Account Name*
                </label>
                <input
                  type="text"
                  id="bankAccountName"
                  className="payment-input"
                  placeholder="Enter Bank Account Name"
                  value={bankAccountName}
                  onChange={(e) =>
                    !viewMode && setBankAccountName(e.target.value)
                  }
                  maxLength={30}  
                  required
                />

                <label className="input-label" htmlFor="ifscCode">
                  IFSC Code*
                </label>
                <input
                  type="text"
                  id="ifscCode"
                  className="payment-input"
                  placeholder="Enter IFSC Code (e.g., SBIN0001234)"
                  value={ifscCode}
                  onChange={(e) =>
                    !viewMode && setIfscCode(e.target.value.toUpperCase())
                  }
                  pattern="^[A-Z]{4}0[A-Z0-9]{6}$"
                  title="IFSC code must be in the format: 4 letters, followed by 0, followed by 6 alphanumeric characters"
                  maxLength={11}
                  required
                /><div className="mobile-view">
                    <label className="input-label" htmlFor="bankReferenceId">
                  Transaction ID*
                </label>
                <input
                  type="text"
                  id="bankReferenceId"
                  className="payment-input"
                  placeholder="Enter Transaction ID"
                  value={bankReferenceId}
                   onChange={(e) =>
                      !viewMode && setBankReferenceId(e.target.value)
                    }
                    maxLength={20}
                    pattern="[A-Za-z0-9]{5,20}"
                    required
                />{" "}
                <label className="input-label" htmlFor="TransDate">
                  Transaction Date*
                </label>
                <input
                  type="date"
                  id="TransDate"
                  className="payment-input"
                  value={transactionDate}
                  onChange={(e) => !viewMode && setTransactionDate(e.target.value)}
                  onClick={handleDateClick}
                  max={maxDate}
                  required
                />
                </div>
              </div>
            </div>
            <div className="left-part">
              <div className="web-view">
              <div className="input-group">
                <label className="input-label" htmlFor="bankReferenceId">
                  Transaction ID*
                </label>
                <input
                  type="text"
                  id="bankReferenceId"
                  className="payment-input"
                  placeholder="Enter Transaction ID"
                  value={bankReferenceId}
                 onChange={(e) =>
                      !viewMode && setBankReferenceId(e.target.value)
                    }
                    pattern="[A-Za-z0-9]{5,20}"
                    maxLength={20}
                />{" "}
                <label className="input-label" htmlFor="TransDate">
                  Transaction Date*
                </label>
                <input
                  type="date"
                  id="TransDate"
                  className="payment-input"
                  value={transactionDate}
                  onChange={(e) => !viewMode && setTransactionDate(e.target.value)}
                  onClick={handleDateClick}
                  max={maxDate}
                  required
                />
              </div>
              </div>
              <div className="license-upload-part">
                <div className="profile-pic">
                  {previewImages.length > 0 ? (
                    previewImages.map((image) => (
                      <img
                        key={image.id}
                        src={image.url}
                        alt="Payment Proof Preview"
                        className="preview-image"
                        onClick={() => handleImageClick(image.url)}
                      />
                    ))
                  ) : (
                    <img src={pro} alt="Default Preview" width="30%" />
                  )}
                </div>
               {!viewMode && (
  <input
    type="file"
    id="paymentFileInput"
    multiple
    accept="image/heic,image/heif,image/jpeg,image/jpg,image/png,image/gif,image/tiff,image/webp,image/bmp,image/x-adobe-dng,image/x-dng,application/pdf,video/mp4,video/quicktime,video/x-matroska,video/webm,video/3gpp,video/x-msvideo,video/hevc,video/h265"

      // accept="image/jpeg,image/jpg,image/png,application/pdf"
    onChange={handleFileUpload}
    style={{ display: "none" }}
  />
)}
{!viewMode && (
  <Button
    variant="primary"
    onClick={() => document.getElementById("paymentFileInput").click()}
    className="upload-btn-modal"
  >
    Upload Payment Proof*
  </Button>
)}
                       {error && <p className="error mob-error">{error}</p>}
                <Button
  variant="primary"
  className="add-evaluator-btn"
  onClick={viewMode ? null : handleSubmitProof}
  disabled={viewMode || isSubmitDisabled || loading}
>
  {viewMode
    ? "Pending"
    : loading
    ? "Submitting..."
    : "Submit Payment Proof"}
</Button>
              </div>
             
            </div>
          </div>
        </div>
      </div>

        {/* Image Modal */}
        {isImageModalOpen && selectedImage && (
          <div className="image-modal-overlay" onClick={handleCloseImageModal}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="image-modal-close"
                onClick={handleCloseImageModal}
              >
                ×
              </button>
              <img
                src={selectedImage}
                alt="Full-size Preview"
                className="full-size-image"
              />
            </div>
          </div>
        )}
      </div>
    // </div>
  );
};